import { Icon, InlineChildren } from '@doordash/design-language'
import * as React from 'react'

type DisclaimerProps = {
  children: JSX.Element
  /**
   * IMPROVE @peterj35-dd: the Icon should be controllable via a prop
   * as well but since typing in design-language is not well
   * supported, not exposing via prop.
   */
}

/**
 * Renders a disclaimer with a light bulb icon, and some text
 */
const Disclaimer: React.FC<DisclaimerProps &
  React.ComponentPropsWithoutRef<'div'>> = ({ children, ...props }) => (
  <InlineChildren size={InlineChildren.Sizes.XSmall} {...props}>
    <Icon type={Icon.Types.InsightLine} size={Icon.Sizes.Small} />
    {children}
  </InlineChildren>
)

export default Disclaimer
